export class PaperTypeItem {

  selected: boolean;
  templateId: number;
  imageUrl: string;
  templateUrl: string;
  name: string;

  constructor(templateId: number, name: string, imageUrl: string, templateUrl: string) {
    this.selected = false;
    this.templateId = templateId;
    this.name = name;
    this.imageUrl = imageUrl;
    this.templateUrl = templateUrl;
  }

}